module.exports = "/images/added_team.png?72f6b328f16aac66552380a7d635739e";